import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class Pass {
  constructor(gl, props = {
    id: 'pass'
  }) {
    _defineProperty(this, "id", void 0);

    _defineProperty(this, "gl", void 0);

    _defineProperty(this, "props", void 0);

    const {
      id
    } = props;
    this.id = id;
    this.gl = gl;
    this.props = { ...props
    };
  }

  setProps(props) {
    Object.assign(this.props, props);
  }

  render(params) {}

  cleanup() {}

}
//# sourceMappingURL=pass.js.map